import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { Container } from "@mui/system";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useProjectsState } from "../../../../../hooks/projectsInfo";
import CallSheetCard from "../../../../components/call-sheet/card";
import InfoCard from "../../../../components/call-sheet/card/infoCard";
import ProjectCard from "../../../../components/call-sheet/card/projetCard";
import LocationModal from "../../../../components/locations/Modal";
import CallSheetModal from "../../../../components/call-sheet/modal/modal";
import ScheduleTable from "../../../../components/call-sheet/schedule";
import LocationCard from "../../../../components/locations/Cards";
import { IInfoCard } from "../../../../../config/interfaces";
import CrewCallSheet from "../../../../components/call-sheet/crew";
import ItemFile from "../../../../components/dropzone/itemFile";
import DropZoneModal from "../../../../components/dropzoneModal";
import usePrompt from "../../../../../hooks/usePrompt";
import {
  useListCreativeDocumentLazyQuery,
  useListLocationsQuery,
  useGetProjectQuery,
  useAddCallSheetMutation,
  useGetParticipantsForCallSheetQuery,
  useGetCallSheetLazyQuery,
  useUpdateCallSheetMutation,
} from "../../../../../../graphql/generated/graphql";
import {
  initialStateCallSheet,
  setDateCallSheet,
  setUnSavedCallSheet,
  useCallSheetState,
  setIdCallSheet,
  setTimeCallSheet,
  setScheduleCallSheet,
  setParticipantByCategory,
  setParticipantsCallSheet,
  setAssignedByCategory,
} from "../../../../../hooks/callSheet";
import { difference } from "lodash";

import {
  FormattedDate,
  twelveTo24Hrs,
  dateToTime,
  formatTime,
} from "../../../../../helper/converters";
import "./index.scss";
import CrewModal from "../../../../components/crewModal";

const NewCallSheetPage = () => {
  const params = useParams();
  const { idCallsheet } = params;
  const [locations, setLocations] = useState<any>([]);
  const [deleteLocation, setDeleteLocation] = useState<any>([]);
  const [filesSelected, setFilesSelected] = useState<any>([]);
  const [itemLocation, setItemLocation] = useState<any>(null);
  const [openLocation, setOpenLocation] = useState(false);
  const [openDropzone, setOpenDropzone] = useState(false);
  const [openCrewModal, setOpenCrewModal] = useState(false);
  const [openSendModal, setOpenSendModal] = useState(false);
  const [addCallSheet] = useAddCallSheetMutation();
  const [UpdateCallSheet] = useUpdateCallSheetMutation();
  const [dayStar, setDayStart] = useState("");
  const [dayEnd, setDayEnd] = useState("");
  const [weather, setWeather] = useState<any>([]);
  const [data, setData] = useState<any>(null);
  const [isLoadingDocs, setIsLoadingDocs] = useState<boolean>(false);
  const navigate = useNavigate();

  const [infoCard, setInfoCard] = useState<IInfoCard>({
    date: "",
    breakfast: "",
    crew: "",
    shooting: "",
    lunch: "",
    meal: "",
    wrap: "",
  });

  const projectsState = useProjectsState();
  const currentProject = projectsState.current.get();
  const callSheetState = useCallSheetState();
  const unsavedFlag = callSheetState.unsaved.get();

  // Request
  const [getCallsheetData, { data: dataUpdate }] = useGetCallSheetLazyQuery();

  const [
    getListCreativeDocument,
    { data: listCreativeDocument, refetch: refetchDocument },
  ] = useListCreativeDocumentLazyQuery();

  const {
    data: listLocations,
    loading,
    refetch,
  } = useListLocationsQuery({
    variables: {
      project_id: currentProject?.id || "",
    },
  });

  const { refetch: refetchParticipants } = useGetParticipantsForCallSheetQuery({
    variables: {
      name_or_email: "",
      project_id: currentProject?.id || "",
    },
  });

  const { data: projectCard, loading: loadingProjectCard } = useGetProjectQuery(
    {
      variables: {
        project_id: currentProject?.id || "",
      },
    }
  );

  // Run one time when the component DidMount
  useEffect(() => {
    initialStateCallSheet();
    if (idCallsheet) {
      //update functionality
      getCallsheetData({
        variables: {
          call_sheet_id: idCallsheet,
        },
      }).then((data) => {
        if (data?.data?.getCallSheet) {
          const callsheet = data.data.getCallSheet;
          const infoCard: any = {};
          const updatedLocations = [];
          const date = callsheet?.date?.split(" ");
          callsheet?.events?.map(
            (item: any) => (infoCard[item?.name] = item?.time)
          );
          let count = 0;
          const updateLocations = callsheet.location?.map((location) => {
            const isEnable = location?.assigned_in_call_sheet;
            if (isEnable) count++;
            return { ...location, order: isEnable ? count : null };
          });
          const sortLocation =
            updateLocations?.filter((location) => location.order) || [];
          const nullLocation =
            updateLocations?.filter((location) => !location.order) || [];
          updatedLocations.push(...sortLocation);
          updatedLocations.push(...nullLocation);
          const selectedFiles = callsheet?.creative_document?.filter(
            (file) => file?.assigned_in_call_sheet
          );
          if (callsheet?.schedule) {
            const scheduleData = callsheet?.schedule.map((row: any) => ({
              id: row.id,
              cast: row.cast,
              description: row.description,
              location: row.location,
              scene: row.scene,
              time: formatTime(row.time),
            }));
            setScheduleCallSheet(scheduleData);
          }
          setLocations(updatedLocations);
          if (callsheet.participant_by_category) {
            const participants = callSheetState.participant.get();
            let participantData: any = [];

            const participantFiltered = callsheet.participant_by_category.map(
              (group) => {
                const userData = group?.users.filter(
                  (item) => item.approved_call_sheet
                );
                const noAssigned = group?.users.filter(
                  (item) => item.approved_call_sheet === false
                );
                if (noAssigned && noAssigned?.length > 0) {
                  noAssigned.map((ele: any) => {
                    const match = participants.filter(
                      (el: any) => el.email === ele.email
                    )[0];
                    if (match)
                      participantData = participantData.concat({
                        ...match,
                        time: callsheet.time ? formatTime(callsheet?.time) : "",
                      });
                  });
                }
                return {
                  name: group?.name,
                  users: userData?.map((e: any) => {
                    const person: any = participants.find(
                      (ele: any) => ele.email === e.email
                    );
                    if (person) {
                      participantData.push({
                        ...person,
                        time: formatTime(e.time_call_sheet),
                      });
                    }
                    return {
                      time: e.time_call_sheet,
                      email: e.email,
                    };
                  }),
                };
              }
            );
            const participantAssignedFiltered =
              callsheet.participant_by_category.map((group) => {
                const userData = group?.users.filter(
                  (item) => item.assigned_in_call_sheet
                );
                const noAssigned = group?.users.filter(
                  (item) => item.assigned_in_call_sheet === false
                );
                if (noAssigned && noAssigned?.length > 0) {
                  noAssigned.map((ele: any) => {
                    const match = participants.filter(
                      (el: any) => el.email === ele.email
                    )[0];
                    if (match)
                      participantData = participantData.concat({
                        ...match,
                        time: callsheet.time ? formatTime(callsheet?.time) : "",
                      });
                  });
                }
                return {
                  name: group?.name,
                  users: userData?.map((e: any) => {
                    const person: any = participants.find(
                      (ele: any) => ele.email === e.email
                    );
                    if (person) {
                      participantData.push({
                        ...person,
                        time: formatTime(e.time_call_sheet),
                      });
                    }
                    return {
                      time: e.time_call_sheet,
                      email: e.email,
                    };
                  }),
                };
              });
            setParticipantByCategory(participantFiltered);
            setAssignedByCategory(participantAssignedFiltered);
          }
          if (selectedFiles) setFilesSelected(selectedFiles);
          setInfoCard(infoCard);
          setDateCallSheet(date[0] + "T00:00:00");
          setDayEnd(callsheet?.day_final?.toString() ?? "");
          setDayStart(callsheet?.day_start?.toString() ?? "");
          if (callsheet?.time) {
            setTimeCallSheet(formatTime(callsheet.time));
          }
          setTimeout(() => {
            setUnSavedCallSheet(false);
          }, 2000);
        }
      });
    }
    getListCreativeDocument({
      variables: {
        project_id: params.projectId ?? "",
      },
    });
    setDateCallSheet(new Date().toString());
    setIdCallSheet(params.projectId ?? "");
    setUnSavedCallSheet(false);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setUnSavedCallSheet(false);
    }, 3000);
  }, []);
  useEffect(() => {
    if (listLocations && listLocations.listLocations) {
      setLocations(
        listLocations.listLocations.map((location, index) => ({
          ...location,
          order: null,
        }))
      );
    }
  }, [listLocations]);

  const onSubmit = async (flag = "") => {
    if (dayStar !== "" || dayEnd !== "") {
      if (!(Number(dayEnd) >= Number(dayStar))) {
        return;
      }
    }
    setUnSavedCallSheet(false);
    const currentTime = callSheetState.time.get();

    const formattedInfoCard = [];

    for (const [key, value] of Object.entries(infoCard)) {
      if (key !== "date") {
        const time = value.includes(" ")
          ? twelveTo24Hrs(value)
          : value || twelveTo24Hrs(currentTime);
        if (idCallsheet) {
          const item: any = dataUpdate?.getCallSheet?.events?.find(
            (event) => event?.name === key
          );
          formattedInfoCard.push({
            id: item?.id,
            name: key,
            time: time.length === 8 ? time.slice(0, time.length - 3) : time,
          });
        } else {
          formattedInfoCard.push({
            name: key,
            time: time.length === 8 ? time.slice(0, time.length - 3) : time,
          });
        }
      }
    }

    const filterSchedule = callSheetState.schedule
      .get()
      .filter((row) => row.scene || row.description || row.cast || row.location)
      .map((row) => {
        return {
          id: row.id,
          scene: row.scene,
          description: row.description,
          cast: row.cast,
          location: row.location,
          time: row.time ? twelveTo24Hrs(row.time) : twelveTo24Hrs(currentTime),
        };
      });

    const filteredParticipant = callSheetState.participant
      .get()
      .map((person: any) => {
        return {
          id: person.id,
          email: person.email,
          time: twelveTo24Hrs(person.time),
        };
      });

    const locationData = locations
      .filter((location: any) => location.order)
      .map((location: any) => ({
        id: location.id,
        order: location.order,
      }));

    const docData =
      filesSelected && filesSelected.length > 0
        ? filesSelected.map((file: any) => file.id)
        : [];

    const weatherData =
      weather.length > 0
        ? {
          temperature: weather[0].temp,
          temperature_max: weather[0].tempmax,
          temperature_min: weather[0].tempmin,
        }
        : {
          temperature: null,
          temperature_max: null,
          temperature_min: null,
        }

    const dataCallSheet: any = {
      title: projectCard?.getProject?.project_name ?? "",
      date: FormattedDate(callSheetState.date.get()),
      comment: callSheetState.comment.get(),
      time: dataUpdate?.getCallSheet?.time
        ? twelveTo24Hrs(currentTime)
        : twelveTo24Hrs(callSheetState.time.get()),
      category: callSheetState.category.get(),
      day_start: Number(dayStar),
      day_final: Number(dayEnd),
      ...weatherData
    };

    if (idCallsheet) {
      let deletedFiles: any = [];
      const deletedParticipantList: any = [];
      let deletedSchedule: any = [];
      let deleteLocationCopy: string[] = [];
      if (dataUpdate) {
        if (dataUpdate.getCallSheet?.creative_document) {
          const updatedFiles = dataUpdate.getCallSheet.creative_document
            .filter((doc: any) => doc.assigned_in_call_sheet)
            .map((item: any) => item.id);
          const currentFiles = filesSelected.map((file: any) => file.id);
          deletedFiles = difference(updatedFiles, currentFiles);
        }

        if (dataUpdate.getCallSheet?.participant_by_category) {
          const updatedParticipant: any = [];
          dataUpdate.getCallSheet?.participant_by_category
            .map((e: any) => e.users)
            .map((s: any) => {
              s.map((y: any) => {
                if (y.assigned_in_call_sheet) updatedParticipant.push(y);
              });
            });
          const participantOriginal = updatedParticipant.map(
            (p: any) => p.email
          );
          const participantUpdated = filteredParticipant.map(
            (p: any) => p.email
          );
          const deletedParticipant = difference(
            participantOriginal,
            participantUpdated
          );
          dataUpdate.getCallSheet?.participant?.map((ele: any) => {
            if (deletedParticipant.includes(ele.user.email)) {
              deletedParticipantList.push({
                id: ele.user.id,
                email: ele.user.email,
              });
            }
          });
        }
        if (deleteLocation)
          deleteLocationCopy = deleteLocation.map((e: any) => e.id);
        if (dataUpdate.getCallSheet?.schedule)
          deletedSchedule = callSheetState.deletedSchedule.get() ?? [];
      }
      dataCallSheet.id = idCallsheet;
      dataCallSheet.add_or_update_events = formattedInfoCard;
      dataCallSheet.add_or_update_location = locationData;
      dataCallSheet.delete_location = deleteLocationCopy;
      dataCallSheet.add_creative_document = docData;
      dataCallSheet.delete_creative_document = deletedFiles;
      dataCallSheet.add_or_update_schedule = filterSchedule;
      dataCallSheet.delete_schedule = deletedSchedule;
      dataCallSheet.add_or_update_participant = filteredParticipant;
      dataCallSheet.delete_participant = deletedParticipantList;
    } else {
      dataCallSheet.project_id = params.id || currentProject?.id || "";
      dataCallSheet.events = formattedInfoCard;
      dataCallSheet.location = locationData;
      dataCallSheet.creative_document = docData;
      dataCallSheet.schedule = filterSchedule;
      dataCallSheet.participant = filteredParticipant;
    }
    const isEdit = !!params.idCallsheet;
    setData({ data: dataCallSheet, isEdit });
    if (flag === "save") {
      try {
        if (dataCallSheet) {
          if (isEdit) {
            const response = await UpdateCallSheet({
              variables: {
                ...dataCallSheet,
              },
            });
            if (response) {
              navigate(`/project/${params.projectId}/call-sheet`);
            }
          } else {
            const response = await addCallSheet({
              variables: {
                ...dataCallSheet,
              },
            });
            if (response) {
              navigate(`/project/${params.projectId}/call-sheet`);
            }
          }
        }
      } catch (e: any) {
        console.error(e);
      }
    }
  };

  const handleCloseCrewModal = () => setOpenCrewModal(false);
  const handleOpenCrewModal = () => setOpenCrewModal(true);

  const handleOpenSendModal = () => {
    onSubmit();
    setOpenSendModal(true);
  };

  const handleSaved = () => {
    onSubmit("save");
  };

  const handleCloseSendModal = () => setOpenSendModal(false);
  const handleCloseLocation = () => {
    setOpenLocation(false);
    refetch();
  };
  const handleCloseDropzone = () => setOpenDropzone(false);

  const handleOpenLocation = () => {
    setItemLocation(null);
    setOpenLocation(true);
  };

  const handleOpenDropzone = () => {
    setOpenDropzone(true);
  };

  const isSelected = (id: string) => {
    return filesSelected.find((file: any) => file.id === id);
  };
  const files =
    listCreativeDocument?.listCreativeDocument?.creative_document?.map(
      (item: any) => item
    );

  const rearrangeLocation = (locationId: any) => {
    if (!unsavedFlag) setUnSavedCallSheet(true);
    const activeLocations = locations
      .filter((location: any) => locationId !== location.id && location.order)
      .map((location: any, index: number) => ({
        ...location,
        order: index + 1,
      }));
    const inactiveLocation = locations.filter(
      (location: any) => !location.order && location.id !== locationId
    );
    const currentLocation = locations.filter(
      (location: any) => location.id === locationId
    );

    if (idCallsheet && currentLocation[0].order)
      setDeleteLocation([...deleteLocation, currentLocation[0]]);

    if (currentLocation[0].order) {
      inactiveLocation.push({ ...currentLocation[0], order: null });
    } else {
      activeLocations.push({
        ...currentLocation[0],
        order: activeLocations.length + 1,
      });
    }
    const locationsArray = activeLocations.concat(inactiveLocation);
    setLocations(locationsArray);
  };

  usePrompt("Are you sure you want to exit before saving?", unsavedFlag);

  return (
    <Container maxWidth="lg">
      <Grid>
        <div className="main-card">
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              md={12}
              lg={4}
              xl={4}
              sx={{ display: "flex" }}
            >
              {!loading && <CallSheetCard currentProject={currentProject} />}
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={4}
              xl={4}
              sx={{ display: "flex" }}
            >
              {!loadingProjectCard && projectCard && (
                <ProjectCard
                  numProject={currentProject?.num_project}
                  projectCard={projectCard}
                  time={dataUpdate?.getCallSheet?.time}
                  category={dataUpdate?.getCallSheet?.category}
                  comment={dataUpdate?.getCallSheet?.comment}
                />
              )}
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={4}
              xl={4}
            >
              {!loading && (
                <InfoCard
                  weather={weather}
                  dayStar={dayStar}
                  dayEnd={dayEnd}
                  setDayStart={(e: any) => setDayStart(e)}
                  setDayEnd={(e: any) => setDayEnd(e)}
                  setWeather={setWeather}
                  zipcode={
                    locations.length > 0 && locations[0].zipcode
                      ? locations[0].zipcode
                      : ""
                  }
                  infoCard={infoCard}
                  onChange={(values: IInfoCard) => setInfoCard(values)}
                />
              )}
            </Grid>
          </Grid>
        </div>
        <div className="location-wrapper">
          <h2>
            Locations
            <span>In order, select the locations of the shoot day</span>
          </h2>
          <button
            type="button"
            onClick={handleOpenLocation}
            className="location-button"
          >
            + New Location
          </button>
          <LocationModal
            open={openLocation}
            close={handleCloseLocation}
            item={itemLocation}
          />
          {locations.map((location: any, index: number) => (
            <Box key={index}>
              <LocationCard
                key={location.id}
                index={index}
                location={location}
                rearrangeLocation={rearrangeLocation}
              />
            </Box>
          ))}
        </div>
        <div className="crew-wrapper">
          <h2>
            Crew
            <span>
              Deselect the Crew members or team that don't belong to your call
              sheet and adjust the call time if needed.
            </span>
          </h2>
          <button
            type="button"
            onClick={handleOpenCrewModal}
            className="crew-button"
          >
            + New Crew
          </button>
          <CrewCallSheet
            assigned={dataUpdate?.getCallSheet?.participant_by_category}
          />
          <CrewModal
            open={openCrewModal}
            onClose={handleCloseCrewModal}
            refetch={refetchParticipants}
          />
        </div>
        <div className="schedule-wrapper">
          <h2>
            Schedule
            <span>
              Adjust the time and type inside the cells to fill up the schedule
            </span>
          </h2>
          {!loading && <ScheduleTable />}
        </div>
        <div className="creative-documents-wrapper">
          <h2>
            Creative documents
            <span>
              Select the "Creative Documents" that you want attached to your
              call sheet
            </span>
          </h2>
          <button
            type="button"
            onClick={handleOpenDropzone}
            className="document-button"
          >
            + Creative Doc
          </button>
          <DropZoneModal
            open={openDropzone}
            onClose={handleCloseDropzone}
            refetch={refetchDocument}
            setIsLoadingDocs={setIsLoadingDocs}
          />
          <Grid
            container
            spacing={2}
          >
            {files && !isLoadingDocs &&
              files.map((file: any, index: number) => (
                <Grid
                  item
                  xs={4}
                  key={`file-content-${index}`}
                  onClick={() => {
                    if (isSelected(file.id)) {
                      setFilesSelected(
                        filesSelected.filter((item: any) => item.id !== file.id)
                      );
                    } else {
                      setFilesSelected([...filesSelected, file]);
                    }
                    if (!unsavedFlag) setUnSavedCallSheet(true);
                  }}
                >
                  <ItemFile
                    key={index}
                    file={file}
                    isSelected={isSelected(file.id)}
                    styles={{ backgroundColor: "white" }}
                    preview
                    removeFile={null}
                  />
                </Grid>
              ))}
            {isLoadingDocs &&
              (
                <Box
                  sx={{
                    textAlign: 'center',
                    padding: '20px'
                  }}
                >
                  <CircularProgress
                    color="secondary"
                    size={35}
                  />
                </Box>
              )
            }
          </Grid>
        </div>

        <Button
          variant="contained"
          sx={{
            mt: 3,
          }}
          onClick={handleOpenSendModal}
        >
          Save and Send
        </Button>
        <Button
          variant="contained"
          sx={{
            mt: 3,
            ml: 3,
          }}
          onClick={handleSaved}
        >
          Save
        </Button>
        <CallSheetModal
          open={openSendModal}
          data={data}
          onClose={handleCloseSendModal}
          id={idCallsheet}
        />
      </Grid>
    </Container>
  );
};

export default NewCallSheetPage;
